import { render, staticRenderFns } from "./Liquids.vue?vue&type=template&id=0d6eaeac&scoped=true&"
import script from "./Liquids.vue?vue&type=script&lang=js&"
export * from "./Liquids.vue?vue&type=script&lang=js&"
import style0 from "./Liquids.vue?vue&type=style&index=0&id=0d6eaeac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6eaeac",
  null
  
)

export default component.exports